import React, { useState, useEffect } from 'react'
import { loaderService } from 'src/services/loaderService'
import { makeStyles } from '@material-ui/core/styles'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1000000,
    color: '#fff',
  },
}))

const Loader = () => {
  const [isVisible, setIsVisible] = useState(false)
  const classes = useStyles()

  useEffect(() => {
    loaderService.onChange((newValue) => {
      setIsVisible(newValue)
    })
  }, [])


  return isVisible ? (
    <Backdrop
      className={classes.backdrop}
      open={isVisible}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : null
}

export { Loader }
